export const getConditionColor = (condition) => {
  if (condition === 'Good' || condition === 'New') return 'success';
  if (condition.includes('Worn')) return 'warning';
  return 'error';
};

export const getConditionStyles = (condition) => {
  if (condition === 'Good' || condition === 'New') {
    return {
      background: 'linear-gradient(135deg, #f6ffed 0%, #d9f7be 100%)',
      border: '1px solid #b7eb8f',
      labelColor: '#389e0d',
      textColor: '#1b5e20',
    };
  }

  if (condition.includes('Worn')) {
    return {
      background: 'linear-gradient(135deg, #fffbe6 0%, #ffe58f 100%)',
      border: '1px solid #ffe58f',
      labelColor: '#d46b08',
      textColor: '#b26a00',
    };
  }

  return {
    background: 'linear-gradient(135deg, #fff1f0 0%, #ffccc7 100%)',
    border: '1px solid #ffa39e',
    labelColor: '#cf1322',
    textColor: '#a61c1c',
  };
};
